import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import utilities from "./utilities/utility";
import firebase from "firebase";
import { firestorePlugin } from "vuefire";
import VueTheMask from "vue-the-mask";
import store from "./store";
import "./registerServiceWorker";

Vue.use(VueTheMask);
Vue.use(require("vue-moment"));
Vue.use(firestorePlugin);
Vue.mixin(utilities.mixin());

Vue.config.productionTip = false;

let app;
firebase.auth().onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      store,
      router,
      render: (h) => h(App),
      created() {
        return this.$store.dispatch("bindServicesRef");
      },
    }).$mount("#app");
  }
});
